export default {
  install (Vue) {
    Vue.modal = Vue.prototype.$modal
  }
}
